import apiClient from '@/utils/apiClient';

export interface Integration {
	name: string;
	businessType: string;
}

const GET_ALL_INTEGRATION = '/api/template-workflow/all-integrations';

export const getAllIntegrations = async (): Promise<Integration[]> => {
	const response = await apiClient.request({
		method: 'GET',
		endPoint: GET_ALL_INTEGRATION,
	});

	if (response.success && response.data) {
		return response.data;
	} else {
		throw new Error('Failed to fetch integrations');
	}
};
